export const flattenForCsv = (
  obj: Record<string, unknown>,
  prefix = ''
): Record<string, unknown> => {
  const result: Record<string, unknown> = {};
  for (const key of Object.keys(obj)) {
    const val = obj[key];
    const fullKey = prefix ? `${prefix}/${key}` : key;
    if (val !== null && typeof val === 'object' && !Array.isArray(val)) {
      Object.assign(
        result,
        flattenForCsv(val as Record<string, unknown>, fullKey)
      );
    } else if (Array.isArray(val)) {
      if (val.length === 0) {
        result[fullKey] = '';
      } else if (
        val.some((item) => item !== null && typeof item === 'object')
      ) {
        val.forEach((item, index) => {
          if (
            item !== null &&
            typeof item === 'object' &&
            !Array.isArray(item)
          ) {
            Object.assign(
              result,
              flattenForCsv(
                item as Record<string, unknown>,
                `${fullKey}/${index}`
              )
            );
          } else {
            result[`${fullKey}/${index}`] = item ?? '';
          }
        });
      } else {
        result[fullKey] = val.join(', ');
      }
    } else {
      result[fullKey] = val ?? '';
    }
  }
  return result;
};

export const normalizeRowsForCsv = (
  rows: Record<string, unknown>[]
): Record<string, unknown>[] => {
  const allKeys = [...new Set(rows.flatMap(Object.keys))];
  const leafKeys = allKeys.filter(
    (key) =>
      !allKeys.some((other) => other !== key && other.startsWith(`${key}/`))
  );
  return rows.map((row) =>
    Object.fromEntries(leafKeys.map((key) => [key, row[key] ?? '']))
  );
};
